






import { Component, Vue } from 'vue-property-decorator';
import { BrandingData } from '@/views/branding/Branding';
import Form from '@/views/branding/components/Form.ts.vue';

@Component({
  components: {
    Form
  }
})
export default class BrandingNew extends Vue {
  private data: BrandingData = {};
  
  async onSuccess (data: BrandingData): Promise<void> {
    if (data && data.id) {
      this.$router.push({
        name: 'edit-branding',
        params: {
          id: data.id as string
        }
      })
    }
  }
}
